import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';

import { MarkdownEditorModule } from '../../components/markdown-editor/markdown-editor.module';
import { ContentProfileComponent } from './content-profile.component';

@NgModule({
  declarations: [ContentProfileComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    ChipModule,
    DropdownModule,
    DynamicDialogModule,
    InputSwitchModule,
    InputTextModule,
    MarkdownEditorModule,
    MultiSelectModule,
    RippleModule,
  ],
  exports: [ContentProfileComponent],
})
export class ContentProfileModule {}
